import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {HttpResponse} from "@angular/common/http";
import {RequestWithErrorHandlerService} from "./request-with-error-handler.service";

@Injectable()
export class LogoutService {
  private onUserLogout = new Subject<void>();

  constructor(private requestService: RequestWithErrorHandlerService) {}

  getUserLogoutObservable(): Observable<void> {
    return this.onUserLogout.asObservable();
  }

  logout(): Observable<HttpResponse<any>> {
    this.onUserLogout.next();
    return this.requestService.post('/logout/device.json', {});
  }
}
